<style>.cta-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-direction: column;
    white-space: nowrap;
    animation: none !important;
    white-space: nowrap;
    margin: 50px 0;
}
.cta-subtitle{
    font-family: 'Manrope' !important;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 22px;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 5px;
}
@media(max-width: 580px) {
    .cta-title {
        font-size: 2rem !important;
        line-height: 2rem !important;
    }
    .cta-subtitle {
        font-size: 1rem !important;
        line-height: 1rem !important;
    }
    .cta-button {
        font-size: 2rem !important;
        line-height: 2rem !important;
    }
}
.cta-title {
    font-family: 'DIN Condensed', serif !important;
    font-size: 64px;
    font-weight: medium;
    letter-spacing: 0;
    line-height: 64px;
    text-align: center;
    text-transform: uppercase;
}
.cta-button {
  	font-family: 'ivypresto-display', serif !important;
    font-size: 42px;
    font-style: italic;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 42px;
    text-align: center;
}
.cta-button:hover {
	cursor: pointer;
}</style>
<template><div class="cta-wrapper">
    <h3 class="cta-subtitle">{{subtitle}}</h3>
    <p class="cta-title">{{title}}</p>
    <a :href="cta" target="_blank" class="no-decoration">
      <span role="link" class="cta-button">{{cta_text}}</span>
    </a>
</div>
</template>
<script>export default {
    props: {
        title: {
        	title: 'Titel',
            type: String,
            default: 'Titel'
        },
        subtitle: {
        	title: 'Subtitel',
            type: String,
            default: 'Subtitel'
        },
        cta_text: {
        	title: 'CTA Text',
            type: String,
            default: 'Klicka här'
        },
        cta: {
        	title: 'CTA Path',
            type: String,
            default: '/path'
        }
    }
}</script>